import { FC } from "react";
import { useMoney } from "../../../hooks/useMoney";

export const PriceRow: FC<{
  label: string;
  value: number;
  negative?: boolean;
}> = ({ label, value, negative }) => {
  const { formatMoney } = useMoney();
  return (
    <div className="flex justify-between self-stretch">
      <p className="text-[1.00rem] font-normal text-[#5E6D77]">{label}</p>
      <p className="text-[1.00rem] font-normal text-gray-900">
        {negative && "-"}
        {formatMoney(value)}
      </p>
    </div>
  );
};
